namespace GeniuzPOS.SalePromoCamp {
    export interface PsPromoApHdForm {
        PromoId: Serenity.StringEditor;
        PromoCampaign: Serenity.LookupEditor;
        PromoName: Serenity.StringEditor;
        PromoDesc: Serenity.StringEditor;
        StartPromoDate: Serenity.DateEditor;
        EndPromoDate: Serenity.DateEditor;
        PromoTimeFg: Serenity.RadioButtonEditor;
        StartPromoTime: Common.EditTimeEditor;
        EndPromoTime: Common.EditTimeEditor;
        PromoDayFg: Serenity.RadioButtonEditor;
        PromoDay: Serenity.LookupEditor;
        PromoShopFg: Serenity.RadioButtonEditor;
        PromoShop: Serenity.LookupEditor;
        PromoCustFg: Serenity.EnumEditor;
        PromoMb: Serenity.LookupEditor;
        PromoStatus: Serenity.EnumEditor;
        PromoApproveFg: Serenity.EnumEditor;
        VenderSharing: Serenity.DecimalEditor;
        PromoApDetailList: PsPromoApDtEditor;
    }

    export class PsPromoApHdForm extends Serenity.PrefixedContext {
        static formKey = 'SalePromoCamp.PsPromoApHd';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsPromoApHdForm.init)  {
                PsPromoApHdForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DateEditor;
                var w3 = s.RadioButtonEditor;
                var w4 = Common.EditTimeEditor;
                var w5 = s.EnumEditor;
                var w6 = s.DecimalEditor;
                var w7 = PsPromoApDtEditor;

                Q.initFormType(PsPromoApHdForm, [
                    'PromoId', w0,
                    'PromoCampaign', w1,
                    'PromoName', w0,
                    'PromoDesc', w0,
                    'StartPromoDate', w2,
                    'EndPromoDate', w2,
                    'PromoTimeFg', w3,
                    'StartPromoTime', w4,
                    'EndPromoTime', w4,
                    'PromoDayFg', w3,
                    'PromoDay', w1,
                    'PromoShopFg', w3,
                    'PromoShop', w1,
                    'PromoCustFg', w5,
                    'PromoMb', w1,
                    'PromoStatus', w5,
                    'PromoApproveFg', w5,
                    'VenderSharing', w6,
                    'PromoApDetailList', w7
                ]);
            }
        }
    }
}
